import VitalsDashboard from "../VitalsDashboard";

export default function SectionEssentials() {
  return <VitalsDashboard />;
}
